module.exports = __webpack_public_path__ + "static/media/expert4.69085837.png";